import React, { useEffect, useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { Link, useLocation } from "react-router-dom";
import { doctor03, male, female } from "../../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import PatientHistory from "../../patients/PatientHistory";
import VitalsDisplay from "../../patients/Vitals_display";
import { SearchOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "react-bootstrap";
import AddPatientPopup from "../../appointmentBooking/AddPatientPopUp";

const PatientsProfile = () => {
  const [patientData, setPatientData] = useState(null);
  const location = useLocation();
    const [editPatient, setEditPatient] = useState(false);
  

  useEffect(() => {
    const { patient } = location?.state || {}; // fallback in case state is missing
    console.log("doctor", patient);
    setPatientData(patient);
  }, []);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const handleFormSubmit = (values) => {
    console.log("Submitted values:", values);
    setIsModalVisible(false);
  };

  const [patientHistory, setPatientsHistory] = useState(true);
    const handleClose = (data) => {
    console.log("updated data", data);
    setEditPatient(false);
    if (data && Object.keys(data).length > 0) {
  setPatientData(data);
    }
  
}
  return (
    <>
      <Header />
      <Sidebar activeClassName="receptionist-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-sm-5 col-6">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/receptionist-dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Patient Profile</li>
                </ul>
              </div>
              {/* <div className="col-sm-7 col-6 text-end  m-b-30">
                <Link
                  to="/edit-profile"
                  className="btn btn-primary btn-rounded"
                >
                  <i className="fa fa-plus" /> Edit Profile
                </Link>
              </div> */}
            </div>
            <div className="card-box profile-header">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link to="#">
                          <img
                            className="avatar-img rounded-circle"
                            src={patientData?.gender == "Male" ? male : female}
                            alt="User Image"
                          />{" "}
                        </Link>
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h2 className="user-name mt-3 mb-0">
                              {patientData?.first_name} {patientData?.last_name}
                            </h2>
                            <small className="text-muted">
                              {patientData?.gender}
                              {", Age : "}
                              {patientData?.age}
                            </small>
                            <div className="staff-id">
                              Patient ID : {patientData?.id}
                            </div>
                            <div className="staff-msg">
                              <Link to="/chat" className="btn btn-primary me-2">
                                Book Appointment
                              </Link>
                              <Link to="/chat" className="btn btn-primary">
                                Walk-in
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-md-7"
                          style={{ position: "relative" }}
                        >
                          <Button
                            className="btn btn-primary btn-sm"
                            style={{
                              position: "absolute",
                              top: "0px", // Aligns it to the top edge of the col-md-7
                              right: "0px", // Aligns it to the right edge of the col-md-7
                            }}
                            onClick={()=> setEditPatient(true)}
                            // You would add your onClick handler here, e.g., onClick={handleEdit}
                          >
                            <i
                              className="fa fa-pencil-square-o"
                              aria-hidden="true"
                            ></i>{" "}
                            Edit
                          </Button>
                          <ul className="personal-info">
                            <li>
                              <span className="title">Phone:</span>
                              <span className="text">
                                <Link to>{patientData?.mobile || "N/A"}</Link>
                              </span>
                            </li>
                            <li>
                              <span className="title">Email:</span>
                              <span className="text">
                                <Link to>{patientData?.email || "N/A"}</Link>
                              </span>
                            </li>
                            <li>
                              <span className="title">Birthday:</span>
                              <span className="text">
                                {patientData?.date_of_birth || "N/A"}
                              </span>
                            </li>
                            <li>
                              <span className="title">Address:</span>
                              <span className="text">
                                {patientData?.street || ""},{" "}
                                {patientData?.city || ""}{" "}
                              </span>
                            </li>
                            <li>
                              <span className="title">Gender:</span>
                              <span className="text">
                                {patientData?.gender}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-box profile-header mt-4">
              <ul className="nav nav-tabs nav-tabs-bottom">
                <li className="nav-item">
                  <Link
                    className="nav-link active" // <-- Make this tab active by default
                    onClick={() => setPatientsHistory(true)}
                    to="#bottom-tab2"
                    data-bs-toggle="tab"
                  >
                    Patient History
                  </Link>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane active" id="bottom-tab2">
                  {" "}
                  {/* <-- Make this pane active by default */}
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-box">
                        <div className="row">
                          <div className="col-md-9">
                            {patientData?.id && (
                             // <PatientHistory patientId={patientData.id} />
                            <span>No data found</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         {editPatient && (
                <AddPatientPopup
                  show={editPatient}
                  handleClose={handleClose}
                  editpatientsdetail={patientData}
                />
              )}
      </>
    </>
  );
};

export default PatientsProfile;
